import React, { useEffect } from "react";

import "./index.scss";
import useGetJobsStatuses from "../../Global/Api/Jobs/getStatuses.api";
import { useDispatch, useSelector } from "react-redux";
import { setActiveJobStatus, setCurrentPage } from "../../Store/Slice/jobsSlice";
import useGetJobs from "../../Global/Api/Jobs/getJobs.api";

export default function JobsTab() {
  const dispatch = useDispatch();
  const getStatuses = useGetJobsStatuses();
  const { statuses, activeStatus } = useSelector((state) => state.rootReducer.jobsSlice);
  useEffect(() => {
    getStatuses.get();
  }, []);

  const handleClick = (status) => {
    dispatch(setCurrentPage(1));
    dispatch(setActiveJobStatus(status));
  }

  const render = () => {
    return statuses?.map((status, index) => (
      <div
        className={`job__tab ${status?.id === activeStatus?.id ? "active" : ""}`}
        id={status?.id}
        key={index}
        onClick={() => handleClick(status)}
      >
        {status?.name}
      </div>
    ));
  };

  return statuses?.length > 0 ? render() : null;
}
